import { computed, watch } from "vue";
import { toast, updateGlobalOptions } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export function configToaster(isDarkMode: boolean) {
  updateGlobalOptions({
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    autoClose: 2000,
    position: "top-center",
    theme: isDarkMode ? "dark" : "light",
    style: {
      width: "auto",
      textAlign: "center",
    },
    hideProgressBar: true,
    closeButton: false,
  });
}

export default toast;
